import {
  sidebarItemClassName,
  sidebarNavigationTheme,
  sidebarItemGroupClassName,
  sidebarSectionHeadingClassName,
} from "./sidebar-styles";
import {
  Sidebar,
  SidebarItems,
  SidebarItemGroup,
  SidebarItem,
  TextInput,
} from "flowbite-react";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { EXPORTS_ENABLED } from "../config/features";
import { useAdminAccess } from "../hooks/useAdminAccess";
import {
  HiChartPie,
  HiSearch,
  HiShoppingBag,
  HiUsers,
  HiLocationMarker,
  HiClipboardList,
  HiUserGroup,
  HiMap,
  HiChartSquareBar,
  HiPresentationChartLine,
  HiRefresh,
  HiMail,
  HiDownload,
  // HiLightningBolt,
} from "react-icons/hi";

const ExampleSidebar: FC = function () {
  const [currentPage, setCurrentPage] = useState("");
  const { hasAccess, hasOwnerAccess, roleId } = useAdminAccess();

  useEffect(() => {
    const newPage = window.location.pathname;
    setCurrentPage(newPage);
  }, [setCurrentPage]);

  return (
    <Sidebar
      theme={sidebarNavigationTheme}
      aria-label="Seitenleiste mit mehrstufigem Dropdown-Beispiel"
      className="h-full overflow-y-auto border-none bg-transparent py-3"
    >
      <SidebarItems>
        <form className="mb-4 px-3 lg:hidden">
          <TextInput
            icon={HiSearch}
            type="search"
            placeholder="Suchen"
            required
            size={32}
            className="sentry-unmask touch-manipulation"
          />
        </form>
        <SidebarItemGroup className={sidebarItemGroupClassName}>
          <SidebarItem
            href="/"
            icon={HiChartPie}
            className={`
              ${sidebarItemClassName}
              ${"/" === currentPage ? "bg-gray-100 dark:bg-gray-700" : ""}
            `}
          >
            Dashboard
          </SidebarItem>

          {hasAccess && (
            <>
              <div className={sidebarSectionHeadingClassName}>
                Management
              </div>
              <SidebarItem
                href="/contract-types"
                icon={HiShoppingBag}
                className={`
                  ${sidebarItemClassName}
                  ${
                    "/contract-types" === currentPage
                      ? "bg-gray-100 dark:bg-gray-700"
                      : ""
                  }
                `}
              >
                Vertragstypen
              </SidebarItem>
              {/*
              <SidebarItem
                href="/admin/bonuses"
                icon={HiLightningBolt}
                className={`
                  ${sidebarItemClassName}
                  ${
                    "/admin/bonuses" === currentPage
                      ? "bg-gray-100 dark:bg-gray-700"
                      : ""
                  }
                `}
              >
                Bonus Regeln
              </SidebarItem>
*/}{" "}
              <SidebarItem
                href="/users/list"
                icon={HiUsers}
                className={`
                  ${sidebarItemClassName}
                  ${
                    "/users/list" === currentPage
                      ? "bg-gray-100 dark:bg-gray-700"
                      : ""
                  }
                `}
              >
                Benutzerliste
              </SidebarItem>
              {EXPORTS_ENABLED && (
                <SidebarItem
                  href="/export"
                  icon={HiDownload}
                  className={`
                    ${sidebarItemClassName}
                    ${
                      "/export" === currentPage
                        ? "bg-gray-100 dark:bg-gray-700"
                        : ""
                    }
                  `}
                >
                  Export
                </SidebarItem>
              )}
              {hasOwnerAccess && (
                <SidebarItem
                  href="/admin/email-audit"
                  icon={HiMail}
                  className={`
                    ${sidebarItemClassName}
                    ${
                      "/admin/email-audit" === currentPage
                        ? "bg-gray-100 dark:bg-gray-700"
                        : ""
                    }
                  `}
                >
                  E-Mail Audit
                </SidebarItem>
              )}
            </>
          )}

          <SidebarItem
            href="/location"
            icon={HiLocationMarker}
            className={`
              ${sidebarItemClassName}
              ${
                "/location" === currentPage
                  ? "bg-gray-100 dark:bg-gray-700"
                  : ""
              }
            `}
          >
            Standort
          </SidebarItem>

          {(hasOwnerAccess || hasAccess) && (
            <>
              <div className={sidebarSectionHeadingClassName}>
                Mitarbeiter
              </div>
              {hasOwnerAccess && (
                <SidebarItem
                  href="/worker-locations"
                  icon={HiMap}
                  className={`
                    ${sidebarItemClassName}
                    ${
                      "/worker-locations" === currentPage
                        ? "bg-gray-100 dark:bg-gray-700"
                        : ""
                    }
                  `}
                >
                  Mitarbeiterstandorte
                </SidebarItem>
              )}
            </>
          )}

          {/* Metrics is gated separately from the staff section: team leads (role 3)
              get it, but not the rest of that block. Row scoping is enforced by the
              RPCs, so a lead only ever sees their own teams' numbers. */}
          {(hasAccess || roleId === 3) && (
            <SidebarItem
              href="/sales-metrics"
              icon={HiPresentationChartLine}
              className={`
                    ${sidebarItemClassName}
                    ${
                      "/sales-metrics" === currentPage
                        ? "bg-gray-100 dark:bg-gray-700"
                        : ""
                    }
                  `}
            >
              Vertriebs-Metriken
            </SidebarItem>
          )}

          <div className={sidebarSectionHeadingClassName}>
            Kundendaten
          </div>
          <SidebarItem
            href="/customers/overview"
            icon={HiClipboardList}
            className={`
              ${sidebarItemClassName}
              ${
                "/customers/overview" === currentPage
                  ? "bg-gray-100 dark:bg-gray-700"
                  : ""
              }
            `}
          >
            Kundenübersicht
          </SidebarItem>
          {(hasAccess || roleId === 3) && (
            <SidebarItem
              href="/customers/all-customers"
              icon={HiUserGroup}
              className={`
                ${sidebarItemClassName}
                ${
                  "/customers/all-customers" === currentPage
                    ? "bg-gray-100 dark:bg-gray-700"
                    : ""
                }
              `}
            >
              Alle Kunden
            </SidebarItem>
          )}
          <SidebarItem
            href="/heatmap"
            icon={HiChartSquareBar}
            className={`
              ${sidebarItemClassName}
              ${
                "/heatmap" === currentPage ? "bg-gray-100 dark:bg-gray-700" : ""
              }
            `}
          >
            Kunden Heatmap
          </SidebarItem>
          {hasAccess && (
            <SidebarItem
              href="/admin/pdf-regeneration"
              icon={HiRefresh}
              className={`
                ${sidebarItemClassName}
                ${
                  "/admin/pdf-regeneration" === currentPage
                    ? "bg-gray-100 dark:bg-gray-700"
                    : ""
                }
              `}
            >
              PDF-Regeneration
            </SidebarItem>
          )}
        </SidebarItemGroup>
      </SidebarItems>
    </Sidebar>
  );
};

export default ExampleSidebar;
